import { DateTime } from "luxon"

const today = DateTime.now()
const oneYearAgo = DateTime.now().minus({ years: 1 })

export const completedTransferParams = { "filter[start_date]": oneYearAgo.toISODate(), "filter[end_date]": today.toISODate() }